import React, { Component } from 'react';
import { toast } from "react-toastify";
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Sample from "../../../assets/Telegram-Message-Sample.png";
import ArrowBackOutlinedIcon from '@material-ui/icons/ArrowBackOutlined';
import ArrowForwardOutlinedIcon from '@material-ui/icons/ArrowForwardOutlined';

import axios from '../../../axios';
import apiError from '../../../error';
import Spinner from '../../spinner/spinner';

export default class TemplatesTelegram extends Component {
    constructor(props) {
        super(props);
        this.state = {
            messageBody: '',
            image: null,
            loading: false,
            savedThumbnail: null,
        };
    }

    componentDidMount() {
        this.load();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.templateId !== this.props.templateId) {
            this.load();
        }
    }

    load = () => {
        if (this.props.templateId) {
            axios.get('/api/telegram-template/' + this.props.templateId)
                .then(res => {
                    const template = res.data.template;
                    if (template) {
                        this.setState({
                            messageBody: template.html || '',
                            savedThumbnail: template.telegramMessageThumbnail || ''
                            // image cannot be prefilled in file input
                        });
                    }
                })
                .catch(apiError);
        }
    };

    handleImageChange = (e) => {
        this.setState({ savedThumbnail: '', image: e.target.files[0] });
    };

    handleCreateTemplate = () => {
        const { messageBody, image } = this.state;

        if (!messageBody.trim()) {
            toast.error('Please enter a message body');
            return;
        }

        const formData = new FormData();
        formData.append('messageBody', messageBody);

        if (image) {
            formData.append('image', image);
        }

        formData.append('campaignTemplateId', this.props.campaignTemplateId);

        const method = this.props.templateId ? 'patch' : 'post';
        const url = '/api/telegram-template/' + (this.props.templateId || '');

        this.setState({ loading: true });

        axios({
            method,
            url,
            data: formData,
            headers: { 'Content-Type': 'multipart/form-data' }
        })
            .then(res => {
                this.setState({ loading: false });
                this.props.handleTabChange('next');
                if (!this.props.templateId) {
                    this.props.handleTemplateId(res.data.template.id);
                }
                toast.success(`Telegram template ${this.props.templateId ? 'updated' : 'created'} successfully`);
            })
            .catch(error => {
                apiError(error);
                this.setState({ loading: false });
            });
    };

    render() {
        return (
            <>
                <div className="email-template-wrap">
                    <div className="rightSectionHeader">
                        <div className="row justify-content-between align-items-center">
                            <div className="col-md-4 tab-right-header">
                                <h6>Message Template</h6>
                                <p>Configure message template</p>
                            </div>
                            <div className="col-md-8 text-right"></div>
                        </div>
                    </div>
        
                    <div className="telegramMessageSection">
                        <div className="row tabTamplate">
                            <div className="col-md-4">
                                <div className="contHeading">
                                    <h6>Message</h6>
                                </div>
                                <Form.Control
                                    as="textarea"
                                    rows={12}
                                    placeholder="Enter message here"
                                    className="message-input"
                                    onChange={(e) => this.setState({ messageBody: e.target.value })}
                                    value={this.state.messageBody}
                                />
                            </div>
        
                            <div className="col-md-4">
                                <div className="contHeading">
                                    <h6>Sample Message</h6>
                                </div>
                                <div className="sample-card">
                                  
                                    <img src={Sample} alt='Sample'/>
                                </div>
                            </div>
                        </div>
        
                        <div className="url-wrapper variablesSection">
                             <div className="contHeading">
                                <h6>Variables</h6>
                             </div>
                            <div className="variableBox">
                                <div className="badgeInfo">
                                    <span className="token">&#123;&#123;.fname&#125;&#125; </span> : 
                                        <span className="label"> First Name</span>
                                </div>
                                <div className="badgeInfo">
                                    <span className="token">&#123;&#123;.lname&#125;&#125; </span> : 
                                        <span className="label"> Last Name</span>
                                </div>
                            </div>
        
                            <div className="badgeInfo mb-3">
                                <span className="token">&#123;&#123;.url&#125;&#125; </span> : 
                                 <span className="label">URL to which user will be landed</span>
                            </div>
        
                            <Form.Group >
                                <Form.Label>Upload Image</Form.Label>
                                <Form.File
                                    className="form-control"
                                    id="exampleFormControlFile1"
                                    type="file"
                                    accept="image/*"
                                    onChange={this.handleImageChange}
                                    style={{ width: '45%' }}
                                />
                                {(this.state.image || this.state.savedThumbnail) && (
                                    <img
                                        src={this.state.savedThumbnail || URL.createObjectURL(this.state.image)}
                                        alt="Preview"
                                        className="img-fluid mt-2"
                                        style={{ maxHeight: 150 }}
                                    />
                                )}
                            </Form.Group>
                        </div>
                    </div>
                </div>
        
            <div className="mt-2">
                <div className="footer-wrapper justify-content-end d-flex ft-padding">
                    <Button className="closeBtn mr-2" onClick={() => this.props.handleTabChange('prev')}>
                        <ArrowBackOutlinedIcon className="btn-icon" /> Previous
                    </Button>
                    <Button
                        variant="success"
                        disabled={this.state.loading}
                        onClick={this.handleCreateTemplate}
                    >
                        <Spinner loading={this.state.loading} />
                        <ArrowForwardOutlinedIcon
                            className={this.state.loading ? "btn-icon d-none" : "btn-icon"}
                        /> Go To Next
                    </Button>
                </div>
            </div>
        </>
        
        );
    }
}
